import React, { useEffect, useState } from 'react'
import isMobile from 'ismobilejs'
import { Carousel, Container, Image } from '@pmi/pmi-iqos-ds-react'
import { constants, Video, LazyImage } from '@pmi/pmi-iqos-shared-react'

const MediaContainer = ({ children }) => {
  return (
    <Container
      display={Container.displays.flex}
      alignItems={Container.alignItemsValues.center}
      justifyContent={Container.justifyContentValues.center}
      fullWidth
      height={['80', '128']}
      p="5">
      {children}
    </Container>
  )
}

const ProductCarousel = ({
  media = [],
  prodImages = [],
  onFullScreenHandler
}) => {
  const defaultImage =
    prodImages && prodImages.length > 0 ? prodImages[0] : null
  const showArrows = !isMobile().any
  const [currentSlide, setCurrentSlide] = useState(0)
  const [playingIndex, setPlayingIndex] = useState(null)
  const [fullScreen, setFullScreen] = useState(false)

  const pauseAllVideos = () => {
    const allVideos = document.querySelectorAll('video')
    allVideos.forEach(v => v.pause())
  }

  const handleChangeImageClick = index => {
    pauseAllVideos()
    setPlayingIndex(index)
    setCurrentSlide(index)
  }

  useEffect(() => {
    if (fullScreen) {
      setTimeout(() => {
        pauseAllVideos()
      }, 1)
    }
  }, [fullScreen])

  return media.length > 0 ? (
    <>
      <Container fullWidth>
        <Carousel
          showArrows={showArrows}
          showFullScreen
          getItemInfo={index => media[index] && media[index].alt}
          data-testing-prefix="ProductDetail"
          onFullScreenHandler={onFullScreenHandler}
          hasThumbnails
          currentSlideIndex={currentSlide}
          setCurrentSlideIndex={i => handleChangeImageClick(i)}
          setIsFullScreen={setFullScreen}>
          {media.map((item, i) => (
            <MediaContainer key={i}>
              {item.type === 'image' ? (
                <Image src={item.path} alt={item.alt} />
              ) : (
                <Video
                  shouldPlay={i === playingIndex && !fullScreen}
                  item={item}
                  defaultImage={defaultImage}
                />
              )}
            </MediaContainer>
          ))}
        </Carousel>
      </Container>
      <Container
        fullWidth
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.center}
        alignItems={Container.alignItemsValues.center}
        pt="4"
        flexWrap>
        {media.map((item, index) => (
          <Container
            key={index}
            rounded={Container.roundedSizes.lg}
            additionalClasses={`q-m-1 ${
              currentSlide === index ? 'q-border' : 'q-p-0-5'
            }`}
            onClickHandler={() => handleChangeImageClick(index)}>
            <Container
              bg={Container.backgrounds.secondary}
              opacity={currentSlide === index ? '0' : '75'}
              width="12"
              height="12"
              position={Container.positions.absolute}
            />
            {item.type === 'video' && (
              <Container
                width="12"
                height="12"
                display={Container.displays.flex}
                position={Container.positions.absolute}
                justifyContent={Container.justifyContentValues.center}
                alignItems={Container.alignItemsValues.center}>
                <Image
                  width="5"
                  height="5"
                  src={`${constants.IMAGE_BASE_URL}/icons8-circled-play-100.png`}
                />
              </Container>
            )}

            <Image width="12" height="12" cover src={item.thumbnail} />
          </Container>
        ))}
      </Container>
    </>
  ) : (
    <MediaContainer>
      <LazyImage />
    </MediaContainer>
  )
}

export default ProductCarousel
